import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from '../Button/Button';
import "./customModel.scss"

interface CustomModalProps {
  show: boolean;
  onHide: () => void;
  message?: string;
}

const CustomModal: React.FC<CustomModalProps> = ({ onHide, ...props }) => {
  // Render modal content
  return (
    <Modal
      {...props}
      aria-labelledby="notification-modal"
      centered
      onHide={onHide}
      className='notification-modal'
    >
      <Modal.Body>
        <div className='custom-modal-section'>
          <h4>{props.message}</h4>
        </div>
        <Button onClick={onHide} btnText='OK' />
      </Modal.Body>
    </Modal>
  );
};

export default CustomModal;